import Vue from 'vue'
import Vuex from 'vuex'
import state from './state.js'
import mutations from './mutations.js'
import actions from './actions.js'
import ES6Promise from 'es6-promise'
import axios from 'axios'
import Constant from '../constant'

ES6Promise.polyfill()
Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  mutations,
  actions
})

export default store

const enhanceAccessToeken = () => {
  state.mainState.menuIndex = localStorage.menuIndex;
  state.mainState.subIndex = localStorage.subIndex;

  state.user_name = localStorage.user_name;
  state.board_detail.contentsNo = localStorage.board_detail_no;
  state.board_detail.type = localStorage.board_detail_type;

  state.access_token = localStorage.accessToken;
  state.login_state = localStorage.login_state;// (state.access_token.length>3)?true:false;

 console.log('## login_state ' + state.login_state)
 console.log('## user_name' + state.user_name)
 console.log('## board_detail' + JSON.stringify(state.board_detail) )

}
enhanceAccessToeken()



// WEBPACK FOOTER //
// ./src/store/index.js